import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

export function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      void navigate(session ? '/' : '/login');
    };
    void checkSession();
  }, [navigate]);

  return (
    <main className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-midnight text-ink">
      <div className="absolute inset-0 -z-10 mesh-midnight">
        <div
          className="aurora-orb aurora-orb-accent animate-aurora-1"
          style={{ width: 380, height: 380, top: '20%', left: '25%', opacity: 0.35 }}
        />
      </div>
      <div className="relative flex flex-col items-center gap-5 animate-fade-in">
        <div className="relative">
          <div className="absolute inset-0 rounded-full blur-2xl bg-accent/40" />
          <svg
            className="relative h-10 w-10 animate-spin text-accent"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
            <path
              className="opacity-90"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-ink-muted">
          Validando credenciais
        </p>
      </div>
    </main>
  );
}
